const storage = sessionStorage;

export const get = (key: string): string | null => storage.getItem(key);

export const set = (key: string, value: string): void =>
  storage.setItem(key, value);

export const clear = (key: string): void => storage.removeItem(key);
